(function() {
  function placeGiftNoteField() {
    var field = document.querySelector('[data-gift-note-property]');
    var buyBlock = document.querySelector('.buy-buttons-block');

    if (!field || !buyBlock) return;

    var variantPicker = buyBlock.querySelector('[data-hide-variants]');
    var quantity = buyBlock.querySelector('.product-form-quantity');

    if (variantPicker && field.previousElementSibling !== variantPicker) {
      variantPicker.insertAdjacentElement('afterend', field);
      return;
    }

    if (!variantPicker && quantity && field.nextElementSibling !== quantity) {
      quantity.insertAdjacentElement('beforebegin', field);
    }
  }

  function updateCounter() {
    var input = document.querySelector('[data-gift-note-input]');
    var counter = document.querySelector('[data-gift-note-counter]');

    if (!input || !counter) return;

    counter.textContent = input.value.length + '/' + (input.getAttribute('maxlength') || '300');
  }

  function schedulePlacement() {
    [0, 50, 150, 300, 600].forEach(function(delay) {
      setTimeout(placeGiftNoteField, delay);
    });
  }

  function init() {
    schedulePlacement();
    updateCounter();

    document.addEventListener('input', function(event) {
      if (event.target.matches('[data-gift-note-input]')) {
        updateCounter();
      }
    });

    document.addEventListener('change', function(event) {
      if (event.target.closest('variant-radios, variant-selects')) {
        schedulePlacement();
      }
    });

    var productRoot = document.querySelector('[id^="MainProduct-"]') || document.body;
    var observer = new MutationObserver(function(mutations) {
      var shouldPlace = mutations.some(function(mutation) {
        return Array.from(mutation.addedNodes).some(function(node) {
          if (node.nodeType !== Node.ELEMENT_NODE) return false;
          return node.matches('variant-radios, variant-selects, [data-hide-variants], .buy-buttons-block') ||
            node.querySelector('variant-radios, variant-selects, [data-hide-variants], .buy-buttons-block');
        });
      });

      if (shouldPlace) schedulePlacement();
    });

    observer.observe(productRoot, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
